import { TdsButton, TdsIcon, TdsTypography } from "@tds/react";
import logo from "../../images/ThalesLogo.png";
import { Trans, useTranslation } from "react-i18next";
import { getMonthRange } from "../../utils/mcdUtils";
import { changeLanguage } from "i18next";
import useLayoutType from "../../hooks/useLayoutType";
import logoPulse from "../../images/pulsetrackerlogo.svg";
import styled from "@emotion/styled";
import { getZoom } from "../../utils/sizeUtils";
import { HZA_IFRAME_URL } from "../../auth/authConfig";
import { useEffect, useRef } from "react";
import ImpersonatingSection from "./ImpersonatingSection";

const StyledHeader = styled("header")(({ theme }) => {
  let zoom = getZoom();
  return {
    ".logo": {
      zoom: `${zoom}%`,
    },
    ".zoom": {
      zoom: `${zoom}%`,
    },
    ".en": {
      zoom: `${zoom}%`,
    },
    ".fr": {
      zoom: `${zoom}%`,
    },
    ".impersonation-banner": {
      borderRadius: "6px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      background: "#ECAF66",
      maxWidth: "50%",
    },

    ".impersonation-info": {
      display: "flex",
      flexDirection: "column",
      color: "#4A3A00",
    },

    ".impersonation-title": {
      fontWeight: 600,
      fontSize: "14px",
    },

    ".impersonation-name": {
      fontSize: "13px",
    },

    ".impersonation-description": {
      fontSize: "12px",
      opacity: 0.8,
    },
  };
});

export default function Header({ step, isAdminOrSU, setEmployee }) {
  const { i18n } = useTranslation();
  const year = new Date().getFullYear();
  const layoutType = useLayoutType();
  const hzaRef = useRef(null);
  const hzaIframeURL = localStorage.getItem(HZA_IFRAME_URL);

  useEffect(() => {
    if (hzaRef && hzaRef.current) {
      const hzaProxyUrl = hzaRef.current.getAttribute("src");
      fetch(hzaProxyUrl)
        .then((response) => {
          if (response.ok) {
            localStorage.setItem("HZA_IFRAME_LOADED", true);
          }
        })
        .catch((e) => {
          console.log("e", e);
          localStorage.setItem("HZA_IFRAME_LOADED", false);
        });
    }
  }, [hzaRef]);

  return (
    <>
      {hzaIframeURL && window.self === window.top && (
        <iframe
          ref={hzaRef}
          id="myFrameHZA"
          style={{
            position: "absolute",
            zIndex: "2",
            top: "60px",
            width: "100%",
            border: 0,
            height: "calc(100% - 101px)",
            display: "none",
          }}
          src={`${hzaIframeURL}/proxy.html`}
          title="description"
        />
      )}
      <StyledHeader>
        <div id="header" className="mdc-header">
          <div className="header-first-row">
            <img className="logo" src={logo} />
            {step === 1 && (
              <div className="language-buttons">
                <TdsIcon
                  classes="zoom text-white-100"
                  icon="language"
                ></TdsIcon>
                <TdsButton
                  id="btnEn"
                  classes={`${i18n.language === "en" && "underline"} en`}
                  onClick={() => changeLanguage("en")}
                >
                  EN
                </TdsButton>
                /
                <TdsButton
                  id="btnFr"
                  classes={`${i18n.language === "fr" && "underline"} fr`}
                  onClick={() => changeLanguage("fr")}
                >
                  FR
                </TdsButton>
              </div>
            )}
          </div>
          <div className="header-items">
            {step === 1 && (
              <div className="header-text">
                <TdsTypography fontSize={5} classes="zoom title">
                  <p>
                    {getMonthRange(i18n.language)} {year}
                  </p>
                </TdsTypography>
                <TdsTypography fontSize={5} classes="zoom title mb-m">
                  <Trans i18nKey="title"></Trans>
                </TdsTypography>
                <div className="subtitle">
                  <div className="subtitle-text">
                    <TdsTypography classes="zoom">
                      <Trans i18nKey="welcome"></Trans>
                    </TdsTypography>
                    <TdsTypography classes="zoom">
                      <Trans i18nKey="email"></Trans>
                      <a href="mailto:tce@thalesgroup.com" className="email">
                        tce@thalesgroup.com
                      </a>
                    </TdsTypography>
                  </div>
                </div>
              </div>
            )}
            {step === 2 && (
              <div className={`${step === 2 ? "container-second" : ""}`}>
                <div id="second-header" className="mdc-header2">
                  <TdsTypography fontSize={5} classes="zoom title">
                    <p>
                      {getMonthRange(i18n.language)} {year}
                    </p>
                  </TdsTypography>
                  <div className="pulse">
                    <TdsTypography fontSize={5} classes="zoom title">
                      <Trans i18nKey="title"></Trans>
                    </TdsTypography>
                  </div>
                </div>
              </div>
            )}
            {layoutType === "desktop" && (
              <div
                className={`${
                  step === 1
                    ? "zoom logo-pulse-first"
                    : " zoom logo-pulse-second"
                }`}
              >
                <img src={logoPulse} />
              </div>
            )}
            <ImpersonatingSection
              layoutType={layoutType}
              step={step}
              isAdminOrSU={isAdminOrSU}
              setEmployee={setEmployee}
            />
          </div>
        </div>
      </StyledHeader>
    </>
  );
}
